import {putMethod} from '~/api'

async function put(orderId, request) {
    return await putMethod(`/api/order/${orderId}/messages/mark_read_count`, request)
}

export {put}
